// ---------------------------------------------
// Shopify API Helper - DeSight Shopify Theme
// ---------------------------------------------
// Funktionen für Shopify API Calls
// ---------------------------------------------

import { fetchJSON } from './helpers.js';

/**
 * Shopify Cart API
 */
export const CartAPI = {
  /**
   * Holt den aktuellen Cart
   * @returns {Promise}
   */
  async get() {
    return fetchJSON('/cart.js');
  },

  /**
   * Fügt ein Produkt zum Cart hinzu
   * @param {Object} item - Item Objekt mit id und quantity
   * @returns {Promise}
   */
  async add(item) {
    return fetchJSON('/cart/add.js', {
      method: 'POST',
      body: JSON.stringify(item)
    });
  },

  /**
   * Aktualisiert Cart
   * @param {Object} updates - Updates Objekt
   * @returns {Promise}
   */
  async update(updates) {
    return fetchJSON('/cart/update.js', {
      method: 'POST',
      body: JSON.stringify(updates)
    });
  },

  /**
   * Ändert Cart Item
   * @param {String} line - Line Item Index
   * @param {Number} quantity - Neue Menge
   * @returns {Promise}
   */
  async change(line, quantity) {
    return fetchJSON('/cart/change.js', {
      method: 'POST',
      body: JSON.stringify({ line, quantity })
    });
  },

  /**
   * Leert den Cart
   * @returns {Promise}
   */
  async clear() {
    return fetchJSON('/cart/clear.js', {
      method: 'POST'
    });
  }
};

/**
 * Shopify Product API
 */
export const ProductAPI = {
  /**
   * Holt Produkt-Daten
   * @param {String} handle - Product Handle
   * @returns {Promise}
   */
  async get(handle) {
    return fetchJSON(`/products/${handle}.js`);
  }
};

/**
 * Shopify Recommendations API
 */
export const RecommendationsAPI = {
  /**
   * Holt Produkt-Empfehlungen
   * @param {String} productId - Product ID
   * @param {Number} limit - Anzahl der Empfehlungen
   * @returns {Promise}
   */
  async get(productId, limit = 4) {
    return fetchJSON(`/recommendations/products.json?product_id=${productId}&limit=${limit}`);
  }
};

